import { Store } from "../Redux/Store";
export default function Headers(val) {
  let user = Store.getState().Auth.user;
  let header = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.token,
  };
  return header;
}
